export default __webpack_public_path__ + "static/6665-29c0b13377c7661c0720563c1c7438b4.jpg";